// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-gray-950[data-v-27403a3e]{background-color:#010314}.close[data-v-27403a3e]{font-size:24px}.close[data-v-27403a3e]:not(:hover){opacity:1}@media(max-width: 991.98px){.close[data-v-27403a3e]{position:absolute;top:30px;right:20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
